const MAX_CONDITION_WORD = 8
const DEFAULT_EMPTY_WORD = '指定なし'

const buildConditionWords = (words: string[]) => {
  if (words.length === 0) {
    return DEFAULT_EMPTY_WORD
  }
  return words.length <= MAX_CONDITION_WORD ? words.join('、') : words.slice(0, MAX_CONDITION_WORD).concat('...').join('、')
}

export default buildConditionWords
